import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie_consent");
    if (!consent) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem("cookie_consent", "accepted");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4" data-testid="cookie-banner">
      <div className="max-w-4xl mx-auto bg-gray-900 text-white rounded-2xl p-5 shadow-2xl flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div className="flex-1">
          <p className="text-sm leading-relaxed">
            Acest site foloseste cookie-uri tehnice pentru a asigura functionarea corecta. 
            Continuand navigarea, esti de acord cu utilizarea acestora. 
            Citeste <Link to="/politica-cookies" className="text-emerald-400 hover:underline">Politica de Cookies</Link>.
          </p>
        </div>
        <button
          onClick={accept}
          className="px-6 py-2.5 bg-emerald-500 text-white rounded-full hover:bg-emerald-600 transition-colors text-sm font-medium whitespace-nowrap"
          data-testid="cookie-accept-btn"
        >
          Accept
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
